'use client';

import { useIntl } from 'react-intl';
import { PageMetaData } from '@packages/modules/src/PageMetaData/PageMetaData';
import { CustomerBookings } from '@packages/order/src/components/CustomerBookings/CustomerBookings.client';
import { KimRating } from '@packages/modules/src/KimRating/KimRating.client';

const BookingsPage = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <PageMetaData page={{ type: 'myaccount', template: 'booking' }} />
      <h1>
        {formatMessage({
          id: 'BookingsPage.Headline',
          defaultMessage: 'Meine Buchungen',
        })}
      </h1>
      <p>
        {formatMessage({
          id: 'BookingsPage.Subheadline',
          defaultMessage:
            'Hier findest du eine Übersicht aller Buchungen auf deinem Baur-Kundenkonto.',
        })}
      </p>
      <CustomerBookings />
      <KimRating pageType="myaccount" templateParams={{ x05: 'BUCH' }} />
    </>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default BookingsPage;
